<template>
  <div
    ref="kt_modal_faturamento_editar_combustivel"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_faturamento_editar_combustivel"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Combustível</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Código de produto da ANP</label>
              <input
                type="text"
                id="txtcProdANP"
                :class="[
                  'form-control mb-2',
                  errosValidacao['cProdANP'] ? 'is-invalid' : '',
                ]"
                v-model="this.refComb.cProdANP"
                maxlength="9"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["cProdANP"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Percentual de Gás Natural (GLP)</label>
              <CurrencyInput
                class="form-control mb-2 text-danger"
                style="text-align: right"
                v-model="this.refComb.pMixGN"
                :class="[
                  'form-control mb-2',
                  errosValidacao['pMixGN'] ? 'is-invalid' : '',
                ]"
                :options="optionsQtd"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["pMixGN"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Código de Autorização (CODIF)</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['CODIF'] ? 'is-invalid' : '',
                ]"
                v-model="this.refComb.CODIF"
                maxlength="21"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["CODIF"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Qtd de combustível ambiente</label>
              <CurrencyInput
                class="form-control mb-2 text-danger"
                style="text-align: right"
                v-model="this.refComb.qTemp"
                :class="[
                  'form-control mb-2',
                  errosValidacao['qTemp'] ? 'is-invalid' : '',
                ]"
                :options="optionsQtd"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["qTemp"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">UF de Consumo</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['UFCons'] ? 'is-invalid' : '',
                ]"
                v-model="this.refComb.UFCons"
              >
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceara</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espirito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Para</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
                <option value="EX">Exterior</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["UFCons"] }}
              </div>
            </div>
          </div>
          <div class="d-flex flex-column mb-5 mx-0">
            <div
              :class="[
                'card card-bordered',
                errosValidacao['CIDE'] ? 'border-danger' : '',
              ]"
            >
              <div class="card-header bg-light min-h-50px">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label fw-bolder fs-3 mb-1"
                    >Informações do CIDE</span
                  >
                </h3>
                <div class="card-toolbar">
                  <div
                    class="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <label
                      class="form-check form-switch form-switch-sm form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input ms-0"
                        type="checkbox"
                        value=""
                        v-model="this.refComb.informarCIDE"
                      />
                      <span
                        class="form-check-label ms-5 fw-bolder fs-6 text-gray-700"
                        >Informar CIDE</span
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="card-body pt-5 pb-2" v-if="this.refComb.informarCIDE">
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
                  >
                    <label class="form-label">BC da CIDE</label>
                    <CurrencyInput
                      class=""
                      :class="[
                        'form-control mb-2',
                        errosValidacao['qBCProd'] ? 'is-invalid' : '',
                      ]"
                      style="text-align: right"
                      v-model="this.refComb.CIDE.qBCProd"
                      :options="optionsQuatro"
                    ></CurrencyInput>
                    <div class="fv-plugins-message-container invalid-feedback">
                      {{ errosValidacao["qBCProd"] }}
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
                  >
                    <label class="form-label">Alíquota CIDE</label>
                    <CurrencyInput
                      class=""
                      :class="[
                        'form-control mb-2',
                        errosValidacao['vAliqProd'] ? 'is-invalid' : '',
                      ]"
                      style="text-align: right"
                      v-model="this.refComb.CIDE.vAliqProd"
                      :options="optionsQuatro"
                    ></CurrencyInput>
                    <div class="fv-plugins-message-container invalid-feedback">
                      {{ errosValidacao["vAliqProd"] }}
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
                  >
                    <label class="form-label">Valor da CIDE</label>
                    <CurrencyInput
                      class=""
                      :class="[
                        'form-control mb-2',
                        errosValidacao['vCIDE'] ? 'is-invalid' : '',
                      ]"
                      style="text-align: right"
                      v-model="this.refComb.CIDE.vCIDE"
                      :options="options"
                    ></CurrencyInput>
                    <div class="fv-plugins-message-container invalid-feedback">
                      {{ errosValidacao["vCIDE"] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CurrencyInput from "@/components/text/CurrencyInput";

const refCombInicializado = {
  cProdANP: "",
  pMixGN: 0,
  CODIF: "",
  qTemp: 0,
  UFCons: "",
  informarCIDE: false,
  CIDE: {
    qBCProd: 0,
    vAliqProd: 0,
    vCIDE: 0,
  },
};

export default {
  components: { CurrencyInput },
  emits: [
    "exibirModalEditarCombustivel",
    "adicionarCombustivel",
    "editarCombustivel",
  ],
  props: {
    index: { type: Number, required: true, default: -1 },
    refCombFaturamento: { type: Object, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = {};
      this.loading = true;

      if (this.validar() === true) {
        this.refComb.informarCIDE = this.$utils.booleanToString(
          this.refComb.informarCIDE
        );
        if (this.index === -1) {
          this.$emit("adicionarCombustivel", this.refComb);
        } else {
          this.$emit("editarCombustivel", this.refComb, this.index);
        }
        hideModal(this.$refs.kt_modal_faturamento_editar_combustivel);
        this.$emit("exibirModalEditarCombustivel", false);
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }

      this.loading = false;
    },
    validar() {
      let result = true;

      if (!this.refComb.cProdANP) {
        this.errosValidacao.cProdANP = "Informe o código de produto da ANP";
        result = false;
      }

      if (!this.refComb.pMixGN) {
        this.errosValidacao.pMixGN =
          "Informe o percentual de Gás Natural para o produto";
        result = false;
      } else if (isNaN(this.refComb.pMixGN)) {
        this.errosValidacao.pMixGN =
          "O percentual de Gás Natural deve ser um número válido";
        result = false;
      }

      if (!this.refComb.CODIF) {
        this.errosValidacao.CODIF =
          "Informe o código de autorização/registro do CODIF";
        result = false;
      }

      if (!this.refComb.qTemp) {
        this.errosValidacao.qTemp =
          "Informe a quantidade de combustível faturada à temperatura ambiente";
        result = false;
      } else if (isNaN(this.refComb.qTemp)) {
        this.errosValidacao.qTemp =
          "A quantidade de combustível deve ser um número válido";
        result = false;
      }

      if (!this.refComb.UFCons) {
        this.errosValidacao.UFCons = "Informe a sigla da UF de consumo";
        result = false;
      }

      if (this.refComb.informarCIDE === true) {
        if (!this.refComb.CIDE.qBCProd) {
          this.errosValidacao.qBCProd = "Informe o valor do BC da CIDE";
          result = false;
        } else if (isNaN(this.refComb.CIDE.qBCProd)) {
          this.errosValidacao.qBCProd =
            "O valor do BC da CIDE deve ser um número válido";
          result = false;
        }

        if (!this.refComb.CIDE.vAliqProd) {
          this.errosValidacao.vAliqProd = "Informe o valor da alíquota da CIDE";
          result = false;
        } else if (isNaN(this.refComb.CIDE.vAliqProd)) {
          this.errosValidacao.vAliqProd =
            "O valor da alíquota da CIDE deve ser um número válido";
          result = false;
        }

        if (!this.refComb.CIDE.vCIDE) {
          this.errosValidacao.vCIDE = "Informe o valor da CIDE";
          result = false;
        } else if (isNaN(this.refComb.CIDE.vCIDE)) {
          this.errosValidacao.vCIDE =
            "O valor da CIDE deve ser um número válido";
          result = false;
        }
      }

      return result;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_editar_combustivel);
      this.$emit("exibirModalEditarCombustivel", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    if (this.index >= 0) {
      this.refComb = JSON.parse(JSON.stringify(this.refCombFaturamento));
      this.refComb.informarCIDE = this.$utils.stringToBoolean(
        this.refComb.informarCIDE
      );
    } else {
      this.refComb = JSON.parse(JSON.stringify(refCombInicializado));
    }
    this.errosValidacao = {};
    this.$utils.requestFocus("txtcProdANP");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      refComb: JSON.parse(JSON.stringify(refCombInicializado)),
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
      optionsQtd: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 3,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
      optionsQuatro: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 4,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
    };
  },
};
</script>

<style></style>
